import React, { useState, useEffect, useRef, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FcApproval,
  FcDisapprove,
  FcCheckmark,
  FcCancel,
} from "react-icons/fc";
import { Button, Row, Col, Table, Spinner, Modal } from "react-bootstrap";
//import Edit from "../Edit";
import Add from "./Add";
import MyJustDate from "../../shared/MyJustDate";
import ErrorModal from "../../ErrorModal";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import * as XLSX from "xlsx";
//import Mekhraz from "../../mechrazeem/Mekhraz";

const baseURL = process.env.REACT_APP_API_JOBS;

const exportToExcel = (data, title) => {
  // Format data
  const formattedData = data.map((item) => ({
    "תעודת זהות": item.idz,
    שם: item.f_name + " " + item.father_name + " " + item.l_name,
    "עמידה בתנאי הסף": item.saf ? "כן" : "לא",
    "עמידה בהשכלה": item.amida_haskala ? "כן" : "",
    "עמידה נסיון ניהולי": item.amida_neholy ? "כן" : "",
    "עמידה נסיון מקצועי": item.amida_meksoey ? "כן" : "",
    "עמידה דרישות נוספות ": item.amida_nosafot ? "כן" : "",
    "טלפון ": item.mobile_phone,
    "הערות ": item.notes,
  }));

  // Create a new worksheet with the formatted data
  const worksheet = XLSX.utils.json_to_sheet(formattedData, { origin: "A2" }); // Start data from A2

  // Add title at the top (merging cells)
  XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });

  // Merge the title row cells across the data columns
  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: range.e.c } }];

  // Adjust row height (increase to make the title appear more prominent)
  worksheet["!rows"] = [{ hpt: 20 }]; // Set the height for the first row

  // Adjust the worksheet after adding the title
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Generate Excel file and download it
  XLSX.writeFile(workbook, "mekhraz-report.xlsx");
};

const Listdelete = ({
  increment,
  counter,
  setCounter,
  visible,
  mekhraz_id,
  mekhraz_title,
  mkh_num,
  mkh_hagasha_date,
}) => {
  const [moamads, setMoamads] = useState([]);
  const [users, setUsers] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const isDisabledDocumentRef = useRef(false);
  const [isDisabledDocument, setIsDisabledDocument] = useState(false);
  const [proposalStatus, setProposalStatus] = useState("");
  const [moamadId, setMoamadId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const [loading, setLoading] = useState(true);
  const [refreshMomads, setRefreshMoamads] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // On mount, restore from ref
    setIsDisabledDocument(isDisabledDocumentRef.current);
  }, []);

  useEffect(() => {
    const getUsers = async () => {
      const response = await axiosPrivate
        .get("auth/users/")
        .then((response) => {
          setUsers(response.data);
        });
    };
    const getProposalStatus = async () => {
      const now = MyJustDate(new Date());
      const response = await axiosPrivate
        .get(baseURL + "genparams")
        .then((response) => {
          setProposalStatus(response.data[0].proposal_status);
          setIsDisabled(
            response.data[0].proposal_status === "חסויה" &&
              MyJustDate(new Date(mkh_hagasha_date)) >= now,
          );

          const newValue =
            response.data[0].proposal_status === "מסמכים חסויים" &&
            MyJustDate(new Date(mkh_hagasha_date)) >= now;

          isDisabledDocumentRef.current = newValue; // ✅ saved in ref, survives remount
          setIsDisabledDocument(newValue);

          /*
          const newValue =
            response.data[0].proposal_status === "מסמכים חסויים" &&
            MyJustDate(new Date(mkh_hagasha_date)) >= now;

          console.trace(`isDisabledDocument changed to: ${newValue}`);
          setIsDisabledDocument(newValue);
          =============================
          setIsDisabledDocument(
            response.data[0].proposal_status === "מסמכים חסויים" &&
              MyJustDate(new Date(mkh_hagasha_date)) >= now,
          );*/
        });
    };
    getUsers();
    getProposalStatus();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "moamad?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setMoamads(response.data);
          setLoading(false);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  }, [refreshMomads]);

  const handleEditClick = (event, mmd) => {
    event.preventDefault();
    setMoamadId(mmd.id);
  };
  const handleCancelClick = () => {
    setMoamadId(null);
  };

  const handeleExportClick = () => {
    //event.preventDefault();
    exportToExcel(moamads, mekhraz_title + " " + mkh_num);
  };
  if (!visible) return;
  if (!moamads) return null;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Add
            setRefreshMoamads={setRefreshMoamads}
            counter={counter}
            mekhraz_id={mekhraz_id}
            users={users}
          />
        </div>
        <div
          className="form-group"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <button onClick={handeleExportClick} className="btn btn-primary">
            יצא רשימת מועמדים לאקסל
          </button>
        </div>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <label style={{ color: "blue" }}>
                הצעה בכחול, היא הצעה חתומה ע"י המועמד
              </label>
              <label style={{ color: "black", fontWeight: "bold" }}>
                {"-----"}
                מספר ההצעות הכולל: {moamads?.length} מתוכם{" "}
                {(moamads?.filter((m) => m.signature_date)).length || 0} נחתמו.
                {"-----"} מספר העומדים בתנאי הסף:{" "}
                {(moamads?.filter((m) => m.saf == true)).length || 0}
              </label>
              <form>
                <Table hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>תנאי סף</th>
                      <th>שם מלא</th>
                      <th>מספר ת"ז</th>
                      <th>דירוג כשירות</th>
                      <th>התקבל</th>
                      <th>פעולות-שינויים,ניהול, הסרה, נבדק-</th>
                    </tr>
                  </thead>
                  <tbody>
                    {moamads?.map((mmd) => (
                      <Fragment key={mmd.id}>
                        <ReadOnlyRows
                          mmd={mmd}
                          handleEditClick={handleEditClick}
                          setRefreshMoamads={setRefreshMoamads}
                          setMoamadId={setMoamadId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                          mekhraz_title={mekhraz_title}
                          isDisabled={isDisabled}
                          isDisabledDocument={isDisabledDocument}
                        />
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>

        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  mmd,
  handleEditClick,
  setMoamadId,
  setRefreshMoamads,
  setShowError,
  setErrorMessage,
  setErrorHeader,
  mekhraz_title,
  isDisabled,
  isDisabledDocument,
}) => {
  let history = useNavigate();
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [deleteReason, setDeleteReason] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [showDeleteMoamadModal, setShowDeleteMoamadModal] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(
      `מחיקת מועמדות של המשתמש "${mmd.f_name} ${
        mmd.father_name ? mmd.father_name + " " : ""
      } ${mmd.l_name}": האם אתה בטוח? `,
    );
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleNevdak = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const changeNevdak = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "moamadnevdak/" + mmd.id + "/",
          {
            signal: controller.signal,
          },
        );

        isMounted && setRefreshMoamads((prev) => !prev);
        alert("המצב עודכן בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    changeNevdak();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const handleDelete = (e) => {
    e.preventDefault();
    async function deletePost() {
      let isMounted = true;
      const controller = new AbortController();
      const getData = async () => {
        try {
          const response = await axiosPrivate.delete(
            baseURL + "moamad/" + mmd.id,
            {
              data: {
                deletereason: deleteReason, // The string you want to send
              },
              signal: controller.signal,
            },
          );
          isMounted && setRefreshMoamads((prev) => !prev);
          alert("נמחקה בהצלחה");
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left",
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };
      getData();
    }
    if (deleteReason != null) {
      deletePost();
    } else {
      alert("חובה לציין סיבת מחיקת ההצעה.");
    }
    setMoamadId(null);
  };
  /*
  const handleAudit = (e) => {
    alert("1111111");
    
  };*/
  return (
    <>
      <Modal show={showDeleteMoamadModal} backdrop="static" keyboard={false}>
        <Modal.Header style={{ display: "flex", justifyContent: "center" }}>
          <Modal.Title>{"נא ציין סיבת המחיקה "}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <textarea
              name="deleteReason"
              cols={50}
              rows={2}
              value={deleteReason}
              onChange={(e) => setDeleteReason(e.target.value)}
              className="form-control"
              id="deleteReason"
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <button className="btn btn-danger" onClick={handleDelete}>
            אשר מחיקה
          </button>

          <button
            className="btn btn-secondary"
            onClick={() => setShowDeleteMoamadModal(false)}
          >
            בטל מחיקה
          </button>
        </Modal.Footer>
      </Modal>

      <tr style={{ color: mmd.signature_date ? "blue" : "black" }}>
        <td>{mmd.id}</td>
        <td style={{ fontSize: "1.75rem" }}>
          {mmd.saf ? <FcApproval /> : <FcCancel />}
        </td>
        <td>
          {mmd.f_name} {mmd.father_name ? mmd.father_name + " " : ""}{" "}
          {mmd.l_name}
        </td>
        <td>{mmd.idz}</td>
        <td>{mmd.ranking}</td>
        <td style={{ fontSize: "1.75rem" }}>
          {mmd.accepted ? <FcApproval /> : <FcCancel />}
        </td>
        <td>
          <Button
            variant="danger"
            value={mmd.id}
            disabled={isDisabled} // Use the isDisabled state
            onClick={() =>
              history("/moamadadmin", {
                state: {
                  moamad_id: mmd.id,
                  user_id: mmd.user,
                  mekhraz_title: mekhraz_title,
                  is_disabled_doc: isDisabledDocument,
                },
              })
            }
          >
            נהל
          </Button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => setShowDeleteMoamadModal(true)}
          >
            הסרה
          </button>
          {"  "}
          <button
            type="button"
            className="btn btn-light"
            onClick={handleNevdak}
          >
            {mmd.nevdak ? <FcCheckmark /> : <FcDisapprove />}
          </button>
        </td>
      </tr>
    </>
  );
};
